import { USER_STAKEHOLDERS } from 'constants/endpoints';
import http from 'utils/http';

export async function fetchUserStakeholders(userId: number) {
  return http.get(USER_STAKEHOLDERS, {
    params: {
      userId,
      includePOCs: true,
    },
  });
}
